import { child, get, getDatabase, ref, set } from "firebase/database";

async function checkUserAllowed(uid) {
    const db = getDatabase();

    try {
        const snapshot = await get(child(ref(db), `/roles/${uid}`));
        if (snapshot.exists()) {
            const data = snapshot.val();

            const roles = Object.entries(data)
                .filter(([key]) => key !== 'company')
                .map(([, value]) => value);

            if (roles.includes('admin') || roles.includes('externo')) {
                return true;
            }
        }

        return false;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
     * Converts a date string in the format "dd-mm-yyyy-HH:MM:SS" to a JavaScript Date object.
     *
     * @param {string} dateString - The date string to convert, expected in "dd-mm-yyyy-HH:MM:SS" format.
     * @returns {Date} The corresponding JavaScript Date object.
     */
function dateStringToDateTime(dateString) {
    let split = dateString.split('-')

    const dd = split[0]
    const mm = split[1]
    const yyyy = split[2]
    const time = split[3]

    return new Date(`${yyyy}-${mm}-${dd}T${time}`)
}

/**
     * Converts a JavaScript Date object to a formatted string "dd-mm-yyyy-hh:mm:ss".
     *
     * @param {Date} date - The date object to format.
     * @returns {string} The formatted date string.
     */
function dateTimeToDateString(date) {
    date = new Date(date)
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const sec = String(date.getSeconds()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy}-${hh}:${min}:${sec}`;
}

function firebaseToString(value) {
    return String(value)
        .replace(/_/g, ' ')
        .replace(/\*/g, '/')
        .replace(/\+/g, '.');
}

function stringToFirebase(value) {
    return String(value)
        .replace(' ', /_/g)
        .replace('/', /\*/g)
        .replace('.', /\+/g);
}

const toggleRole = async (add, value, uid, companyName = null) => {
    const db = getDatabase();
    const roleRef = ref(db, `roles/${uid}`);

    try {
        const snapshot = await get(roleRef);
        let data = snapshot.exists() ? snapshot.val() : {};

        const roles = Object.entries(data)
            .filter(([key]) => key !== 'company')
            .map(([, value]) => value);

        if (add) {
            if (!roles.includes(value)) {
                data[roles.length] = value;
            }
        } else {
            const filtered = roles.filter(role => role !== value);
            data = {};
            filtered.forEach((role, index) => {
                data[index] = role;
            });
        }

        if (companyName) {
            data.company = companyName;
        }

        await set(roleRef, data);
        console.log(`Role ${add ? 'added' : 'removed'} for UID: ${uid}`);
    } catch (error) {
        console.error("Error updating roles:", error);
    }
};

export { checkUserAllowed, firebaseToString, stringToFirebase, toggleRole, dateStringToDateTime, dateTimeToDateString };
